import React, { useState, useEffect } from 'react';
import { COLORS, FONTS, cardStyle, primaryButtonStyle, secondaryButtonStyle } from './signupStyles';
import { StepIndicator } from './StepIndicator';

const useConfetti = () => {
  const [pieces, setPieces] = useState([]);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const colors = [COLORS.salmon, COLORS.peach, COLORS.gold, COLORS.green, COLORS.blue, '#9b59b6', '#e67e22', '#fff1b2'];
    const generated = Array.from({ length: 150 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 3,
      duration: 3 + Math.random() * 2,
      color: colors[Math.floor(Math.random() * colors.length)],
      size: 8 + Math.random() * 8,
      rotation: Math.random() * 360,
      isCircle: i % 3 === 0
    }));
    setPieces(generated);
    setShow(true);
    const timer = setTimeout(() => setShow(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  return { pieces, show };
};

export const StepSuccess = ({ formData, onGoToReflect, onBackToHome }) => {
  const { pieces, show } = useConfetti();
  const displayName = formData.preferredName || formData.firstName || 'friend';

  return (
    <div style={{
      minHeight: '80vh',
      backgroundColor: COLORS.bg,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '80px 20px 40px',
      fontFamily: FONTS.system,
      position: 'relative',
      overflow: 'hidden'
    }}>
      <style>{`
        @keyframes confettiFall {
          0% { transform: translateY(-100px) rotate(0deg); opacity: 1; }
          100% { transform: translateY(100vh) rotate(720deg); opacity: 0; }
        }
        @media (max-width: 480px) {
          .signup-success-card { padding: 32px 24px !important; }
        }
      `}</style>

      {show && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', zIndex: 1000 }}>
          {pieces.map((p) => (
            <div key={p.id} style={{
              position: 'absolute',
              left: `${p.left}%`,
              top: '-20px',
              width: `${p.size}px`,
              height: `${p.size}px`,
              backgroundColor: p.color,
              borderRadius: p.isCircle ? '50%' : '2px',
              animation: `confettiFall ${p.duration}s ease-out ${p.delay}s forwards`,
              transform: `rotate(${p.rotation}deg)`
            }} />
          ))}
        </div>
      )}

      <div className="signup-success-card" style={{ ...cardStyle, textAlign: 'center' }}>
        <StepIndicator currentStep={3} totalSteps={4} stepLabels={['Personal', 'About You', 'Health', 'Done']} />

        <div style={{
          width: '72px', height: '72px',
          backgroundColor: COLORS.text,
          borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 24px'
        }}>
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <h1 style={{ fontFamily: FONTS.serif, fontSize: 'clamp(24px, 5vw, 32px)', fontWeight: '700', color: COLORS.text, margin: '0 0 12px' }}>
          You're in, {displayName}.
        </h1>
        <p style={{ fontSize: '16px', color: COLORS.muted, lineHeight: '1.6', margin: '0 0 32px' }}>
          Your first Reflect session is ready. Answer a few questions about your condition, see how others responded, and start earning.
        </p>

        <button
          onClick={onGoToReflect}
          style={{
            ...primaryButtonStyle,
            width: '100%',
            padding: '16px 24px',
            marginBottom: '12px'
          }}
          onMouseEnter={(e) => { e.target.style.backgroundColor = '#3a3a39'; }}
          onMouseLeave={(e) => { e.target.style.backgroundColor = COLORS.text; }}
        >
          Start Your First Session
        </button>
        <button
          onClick={onBackToHome}
          style={{
            ...secondaryButtonStyle,
            width: '100%',
            border: 'none',
            color: COLORS.muted,
            fontSize: '14px',
            padding: '10px 24px'
          }}
        >
          I'll do this later
        </button>
      </div>
    </div>
  );
};
